import React from 'react'

const BusinessInqueriesButton = () => {
  return (
    <div className="nav__inner-buttons">
      <a
        href="#footer"
        className="button primary"
        aria-label="Contact us for business inquiries"
        role="button"
        title="Get in touch for business partnerships or inquiries"
      >
        Business Inquiries
      </a>
    </div>
  )
}

export default BusinessInqueriesButton